export const _LOAD_MODEL_ = 'Load:CustomerModel';
export const _DELETE_CUSTOMER_ = 'Delete:Customer';
export const _FINISHED_SAVE_REQUEST_ = 'SaveRequest:Finished';
export const _SALVE_CUSTOMER_SUCCESS_ = 'Salve:CustomerSuccess';

export const ADDRESS = {
  id: null,
  city: '',
  label: 'Endereço Principal',
  state: '',
  number: '',
  street: '',
  address: '',
  country: 'BR',
  zipcode: '',
  address2: null,
  district: '',
};

export const CONTACT = {
  id: null,
  name: '',
  email: '',
  phone: '',
};

export const MODEL = {
  id: null,
  name: '',
  type: 'individual',
  email: '',
  phone: '',
  comment: '',
  document: '',
  contacts: [{ ...CONTACT }],
  addresses: [{ ...ADDRESS }],
  started_at: new Date(),
  state_registration: '',
};
